import i18next, { TFunction } from "i18next";

// i18next is initialised once in src/i18n.ts (imported from index.tsx). Do not re-init here.
export function getTranslationObject(): TFunction {
    return i18next.t;
}
